module.exports={
	"Form": "MixDesignViewManifest",
	"Scope": "MixDesign-View",
	"Descriptors":
	{
		"MixDesignDetails.MaterialCode":
		{
			"Name": "Material Code",
			"Hash": "MixDesign-View-MaterialCode",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 4,
				"Section": "MixDesign-View-Identity",
				"Group": "MixDesign-View-Identity"
			}
		},
		"MixDesignDetails.Name":
		{
			"Name": "Name",
			"Hash": "MixDesign-View-Name",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "1",
				"Width": 6,
				"Section": "MixDesign-View-Identity",
				"Group": "MixDesign-View-Identity"
			}
		},
		"MixDesignDetails.IDMaterial":
		{
			"Name": "Material",
			"Hash": "MixDesign-View-IDMaterial",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "Material",
				"SearchFields":
				[
					"Name",
					"MaterialCode",
					"ItemCode"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.IDOrganization":
		{
			"Name": "Organization",
			"Hash": "MixDesign-View-IDOrganization",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "Organization",
				"SearchFields":
				[
					"Name",
					"VendorCode",
					"FederalTaxCode"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.LPSyncDate":
		{
			"Name": "LPSync Date",
			"Hash": "MixDesign-View-LPSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "2",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.HLSyncDate":
		{
			"Name": "HLSync Date",
			"Hash": "MixDesign-View-HLSyncDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.MixID":
		{
			"Name": "Mix ID",
			"Hash": "MixDesign-View-MixID",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "3",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.Description":
		{
			"Name": "Description",
			"Hash": "MixDesign-View-Description",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "4",
				"Width": 12,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details"
			}
		},
		"MixDesignDetails.IDMixType":
		{
			"Name": "Mix Type",
			"Hash": "MixDesign-View-IDMixType",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "Picker",
				"Row": "5",
				"Width": 4,
				"Section": "MixDesign-View-Details",
				"Group": "MixDesign-View-Details",
				"Entity": "MixType",
				"SearchFields":
				[
					"Name",
					"Code",
					"Description"
				],
				"ReadOnly": true
			}
		},
		"MixDesignDetails.IDMixDesign":
		{
			"Name": "IDMix Design",
			"Hash": "MixDesign-View-IDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.GUIDMixDesign":
		{
			"Name": "GUIDMix Design",
			"Hash": "MixDesign-View-GUIDMixDesign",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.CreateDate":
		{
			"Name": "Create Date",
			"Hash": "MixDesign-View-CreateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "6",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.CreatingIDUser":
		{
			"Name": "Creating IDUser",
			"Hash": "MixDesign-View-CreatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.UpdateDate":
		{
			"Name": "Update Date",
			"Hash": "MixDesign-View-UpdateDate",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		},
		"MixDesignDetails.UpdatingIDUser":
		{
			"Name": "Updating IDUser",
			"Hash": "MixDesign-View-UpdatingIDUser",
			"DataType": "String",
			"PictForm":
			{
				"InputType": "ReadOnly",
				"Row": "7",
				"Width": 4,
				"Section": "MixDesign-View-DataAudit",
				"Group": "MixDesign-View-DataAudit"
			}
		}
	},
	"Sections":
	[
		{
			"Name": "Identity",
			"Hash": "MixDesign-View-Identity",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Identity",
					"Hash": "MixDesign-View-Identity",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Details",
			"Hash": "MixDesign-View-Details",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Details",
					"Hash": "MixDesign-View-Details",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		},
		{
			"Name": "Data Audit",
			"Hash": "MixDesign-View-DataAudit",
			"Solvers": [],
			"ShowTitle": true,
			"Groups":
			[
				{
					"Name": "Data Audit",
					"Hash": "MixDesign-View-DataAudit",
					"Rows": [],
					"RecordSetSolvers": [],
					"ShowTitle": false
				}
			]
		}
	]
}
